import { FC } from 'react';

import { IconCircleTickFilled } from 'src/general/Icons/IconCircleTickFilled';
import { BasicModal } from 'src/general/components/BasicModal/BasicModal';
import { Button } from 'src/general/components/Button/Button';
import { Image } from 'src/general/components/Image/Image';

type Props = {
  isOpen: boolean;
  close?: () => void;
};

type ModalListContent = {
  title: string;
  description: string;
};

const modalListContent: ModalListContent[] = [
  {
    title: 'Premium mechanical protection',
    description:
      'Platinum mechanical protection, equivalent to a new car coverage. With higher claims - up to the purchase price of the vehicle.',
  },
  {
    title: 'Premium Roadside Assist',
    description: 'Nationwide breakdown help for the life of your coverage. Also includes extra such as a courtesy car.',
  },
  {
    title: 'Choice of term',
    description: 'Choose from either 1, 3 or 5 years coverage.',
  },
];

export const WarrantyInfoModal: FC<Props> = ({ isOpen, close }) => (
  <BasicModal id="warranty-modal" isOpen={isOpen} onClose={close} title="Carma Extended Coverage">
    <div className="c-fs-body2 flex flex-col gap-4 text-tex-def-tie2">
      <p>Purchase Carma Extended Coverage and drive with confidence knowing your car is protected.</p>

      <ul className="flex flex-col gap-4">
        {modalListContent.map(({ title, description }) => (
          <ModalListItem key={title} title={title} description={description} />
        ))}
      </ul>

      <Image
        src="https://img.carma.com.au/ui-assets/WarrantyInfoModal/carma-extended-coverage.png"
        alt="Extended coverage illustration"
        width={420}
        height={236}
        className="h-auto w-full"
      />

      <p>Let us know if you’d like to add Extended Coverage to your purchase, and we’ll take care of the rest.</p>

      <Button variant="primary" size="small" href="/extended-coverage" fullWidth>
        More about Carma Extended Coverage
      </Button>
    </div>
  </BasicModal>
);

const ModalListItem: FC<ModalListContent> = ({ title, description }) => {
  return (
    <li className="flex gap-2">
      <div className="text-for-suc-bas">
        <IconCircleTickFilled />
      </div>
      <div className="flex flex-col gap-1 pt-0.5">
        <p className="font-extrabold text-tex-def-tie1">{title}</p>
        <p>{description}</p>
      </div>
    </li>
  );
};
